import qs from 'querystring';

export const appendParams = (url, params) => {
  const p = qs.stringify(params);
  return url + (p ? `?${p}` : '');
};
